/* eslint-disable */
import axios from "axios";
import "/src/assets/css/animate.css";
import "/src/assets/css/style.css";
import { useStore } from "vuex";
import moment from "moment";
import graph from "../../custom_lib/graph_lib/graph.vue";
import jwt_decode from "jwt-decode";
import showformmodel from "../showformmodel/showformmodel.vue"
import store from "@/store";
// let testarray= [];
export default {
  name: "nursesummary",
  components: {graph, showformmodel},
  async mounted() {
    let graphtype = localStorage.getItem("graphType");
    if(graphtype && graphtype != ""){
    this.selectedLayout = graphtype;
    }
     const idtoken = store.getters.getIdToken;
     this.email = jwt_decode(idtoken).email;
     await this.getuserid();
    window.addEventListener("studyIdChanged", async (event) => {
          this.currentstudyid = store.getters.getStudyIs;
          this.getcount();
          this.getchartdetails();
        });
    this.currentstudyid = store.getters.getStudyIs;
    this.defaultdate = localStorage.getItem("dateformat");
    this.defaultdashboard = store.getters.getdefaultdashboard;
    this.sndcharts = null;
    this.roleprivileges = await store.getters.getRolesprivilegeData;
    this.valnow = await store.getters.getStudyIs;
    this.getcount();
    this.getcolorcodes();
    this.getchartdetails();
    
  },
  data() {
    return {
      collapsedtypes:[],
      selectedLayout: "cose",
      customlabel:[{
        Nodetype: "Visit",
        Custlabel:"label"
        }],
         popup: { show: false, type: '', x: 0, y: 0 },
      menuitems:["expandNode","collapseNode","showproperties","showformmodel"],
      graphdata:{},
      legendStatus: {
      },
      currentstudyid:"",
      defaultdate: "",
      defaultdashboard: "",
      activeformcount: "",
      showFilter:false,
      dropdownOpen:false,
      selectedcolumnobj:{},
      submittedforms: "",
      completedvisitcount: "",
      userscountstd: "",
      totalvisits: "",
      overduevisitcount: "",
      pageNumber: 1,
      currentStudy: "",
      userId: "",
      baseUrl: `${process.env.VUE_APP_Service_URL}/management/study/`,
      baseapi: process.env.VUE_APP_Service_URL,
      valnow: "",
      roleprivileges:"",
      selectedpatient:"",
      typeArray :[],
      selectedorientation:"LR",
      spinner:false,
      email:"",
      setshowFormModal:false,
      detailspopup:false,
      nodeproperties: null,
      dictionaryfordetails:{
        "FormName":"Form Name",
        "FormId":"Form Id",
        "FormStatus":"Form Status",
        "VisitNo":"Visit No",
        "VisitName":"Visit Name",
        "VisitType":"Visit Type",
        "VisitDate":"Visit Date",
        "Visit Status": "Visit Status",
        
      },
    };
  },
   watch: {
      selectedLayout(){
        if(this.selectedLayout != "klay" && this.selectedLayout != "dagre"){
          this.collapsedtypes=[];
        }
        else{
          this.collapsedtypes=["Visit","End Node","Start Node"];
        }
      },
      graphdata(){
        this.typeArray = this.graphdata.nodes.map(node => node.properties.Type);
      }
    },
  methods: {
    async showproperties(selectedNode) {
     console.log("selectednode,",selectedNode);
      this.nodeproperties = selectedNode;
      this.detailspopup = true;
    },
    closedetailsModal() {
      this.detailspopup = false;
    },
    async getuserid(){
          const idtoken = store.getters.getIdToken;
          await axios
        .get(`${this.baseapi}/forms/epro/getsubbyemail`,

          {
            headers: {
              Authorization: "Bearer " + idtoken,

              "Content-Type": "application/json",
            },
          }
        )

        .then((res) => {
          this.selectedpatient = res.data.id;
        })

        .catch((err) => {
          console.log(err);
        });
    },
    layouconfigchange(){
      this.$refs.childComp.selectorientationfun(this.selectedorientation);
    },
    getchartdetails(){
      console.log("this.selectedpatient",this.selectedpatient);
      if(this.selectedpatient != ""){
          this.getcolorcodes();
          this.graphbasedpatient();
        }
        else{
          alert("Subject Not Found");
        }
    },
    async graphbasedpatient() {
      const idtoken = store.getters.getIdToken;
      console.log("inside graphbasedpatient")
      this.spinner = true;
      try {
        // Get full tree data from backend.
        const graphapiresult = await axios.get(
          `${this.baseapi}/management/graph/getpatientgraphdatabystudyid?studyId=${this.currentstudyid}&patientID=${this.selectedpatient}`,
          {
            headers: { Authorization: `Bearer ${idtoken}` },
          }
        );
        this.graphdata = graphapiresult.data;
        this.spinner = false;
      } catch (error) {
        console.error("Error loading graph:", error);
        this.spinner = false;
      }
    },
async getcolorcodes(){
      const idtoken = store.getters.getIdToken;

      await axios

        .get(
          `${this.baseapi}/management/statusmaster/getall`,

          {
            headers: {
              Authorization: "Bearer " + idtoken,

              "Content-Type": "application/json",
            },
          }
        )

        .then((res) => {
          this.legendStatus={};
          this.legendStatus = this.groupStatusByType(res.data);
        })

        .catch((err) => {
          console.log(err);
        });
    },
    groupStatusByType(apiResult) {
      return apiResult.reduce((acc, curr) => {
        const { statusType, status, colorCode } = curr;
        if (!acc[statusType]) {
          acc[statusType] = [];
        }
        // Add a new object with "label" and "color" properties
        acc[statusType].push({ label: status, color: colorCode });
        return acc;
      }, {});
    },
    async showformmodel(currentform){
    if(currentform.FormId ){
      this.currentform = currentform.FormId;
      this.currentformstatus=currentform.FormStatus;
      this.setshowFormModal = true;
    }
      console.log("currentform",currentform);
  },
  async closeformModal(){
    this.setshowFormModal = false;
  },

getIconName(key) {
      const iconMap = {
        'Form node': 'bottom-round-rectangle',
        'Activity node': 'concave-hexagon',
        'Study': 'diamond',
        'Start-end': 'ellipse',
        'Visit': 'octagon',
        'Site': 'Pentagon',
        'Subject': 'Rectangle',
        'Form': 'round-rectangle',
        'Activity': 'round-tag'
      };
      return iconMap[key];
    },
    legendStatus: {
      'Form node': [
        { label: 'Ongoing', color: '#000000' },
        { label: 'Withdrawn', color: '#95A9B9' },
        { label: 'Enrolled', color: '#A7DC7F' },
        { label: 'New', color: '#A7C7E7' },
        { label: 'Terminated', color: '#FF7163' },
        { label: 'Completed', color: '#0EDBB1' },
        { label: 'Closed', color: '#F7C6C7' },
        { label: 'Open', color: '#B5EAD7' },
        { label: 'Archived', color: '#D3D3D3' },
      ],
      'Site': [
        // Add site-specific statuses
      ],
      // Add other categories
    },
    showPopup(type, event) {
      const legendItem = event.currentTarget;
      const rect = legendItem.getBoundingClientRect();
      
      this.popup = {
        show: true,
        type,
        x: rect.left - 150,
        y: rect.top
      };
    },
    hidePopup() {
      this.popup.show = false;
    },
    jwtDecrypt(token) {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
      return JSON.parse(jsonPayload);
    },
    async getcount() {
      const idtoken = store.getters.getIdToken;
      this.valnow = await store.getters.getStudyIs;
      console.log("current study value is " + this.valnow);
      this.gettotalvisits(this.valnow, idtoken);
      this.getcompletedvisitcount(this.valnow, idtoken);
      this.getsubmittedforms(this.valnow, idtoken);
      this.getoverduevisitcount(this.valnow, idtoken);
    },
    async getsubmittedforms(currentstudyid, idtoken) {
      await axios
        .get(
          `${this.baseapi}/forms/forms/invformcount?studyId=${currentstudyid}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.submittedforms = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },


    async getcompletedvisitcount(currentstudyid, idtoken) {
      await axios
        .get(
          `${this.baseapi}/management/patientschedule/overduecompletedcount?StudyId=${currentstudyid}&PatientID=${this.selectedpatient}&VisitStatus=Completed`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.completedvisitcount = res.data.Completed;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getoverduevisitcount(currentstudyid, idtoken) {
      await axios
          .get(
              `${this.baseapi}/management/patientschedule/overduecompletedcount?StudyId=${currentstudyid}&PatientID=${this.selectedpatient}&VisitStatus=Overdue`,
              {
                  headers: {
                      "Access-Control-Allow-Origin": "localhost:8080",
                      Authorization: "Bearer " + idtoken,
                      "Content-Type": "application/json",
                  },
              }
          )
          .then((res) => {
              this.overduevisitcount = res.data.Overdue;

          })
          .catch((err) => {
              console.log(err);
          });
  },
    async gettotalvisits(currentstudyid, idtoken) {
      await axios
        .get(
          `${this.baseapi}/management/patientschedule/overduecompletedcount?StudyId=${currentstudyid}&PatientID=${this.selectedpatient}&VisitStatus=`,
          {
            headers: {
              "Access-Control-Allow-Origin": 'localhost:8080', 
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if(Object.keys(res.data).length == 0){
            this.totalvisits = 0;
          }
          else{
          this.totalvisits = res.data.TotalCount;
        }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async studychange(val) {
      // store.commit(setStudy,val);
      await store.dispatch("setStudyID", val);
      await this.getcount();
      await this.GetChartData();
      await this.GetqueryChartData();
    },
    // loadstudy function
    filter(data){
      if(data){
          return moment(data).format(this.defaultdate)
      }
    },


  },
};